import React, { useEffect, useState } from 'react'
import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerOverlay } from '@chakra-ui/react'
import DrilldownHeader from '../../ui/Layout/DrilldownHeader'
import PropTypes from 'prop-types'
import { ChartItem } from './ChartItem'

const ChartDrawer = ({ title, reportId, drillDownInfo, ...rest }) => {
  const [drillDownList, setDrillDownList] = useState([])
  useEffect(() => {
    if (drillDownInfo?.linkages?.values) {
      setDrillDownList(Array.from(drillDownInfo?.linkages?.values()))
    }
  }, [drillDownInfo, reportId])
  return (
    <Drawer
      portalProps="containerRef"
      trapFocus={false}
      size="lg"
      {...rest}>
      <DrawerOverlay />
      <DrawerContent
        maxW={{
          base: 'calc(100% - 40px)',
          lg: 'calc(100% - 400px)',
        }}>
        <DrilldownHeader title={title} />
        <DrawerCloseButton
          position="fixed"
          top="30px"
          left="-4"
          backgroundColor="#F5F5F5"
          borderRadius="50%"
          boxShadow="0 2px 4px 0 rgb(0 0 0 / 10%)"
        />
        <DrawerBody>
          <>
            {drillDownList.map(chartId => (
              <ChartItem
                key={chartId}
                index={chartId}
                chartId={chartId}
                data-chart-id={chartId}
              />
            ))}
          </>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

ChartDrawer.propTypes = {
  title: PropTypes.string,
  drillDownInfo: PropTypes.object,
}

export default ChartDrawer
